// removed by extract-text-webpack-plugin
module.exports = {"base":"InfoButton_base--3cNqo","icon":"InfoButton_icon--2YFuG","caption":"InfoButton_caption--3y4uF"};


//////////////////
// WEBPACK FOOTER
// ./components/InfoButton/InfoButton.scss
// module id = 2419
// module chunks = 11